<div class="flex flex-col gap-8 animate-fadeIn p-6 w-full max-w-3xl">
  <div class="flex items-center gap-3.5">
    <div class="shrink-0 w-11 h-11 rounded-2xl bg-primary/10 flex items-center justify-center">
      <i class="pi pi-shield text-primary text-lg"></i>
    </div>
    <div class="flex flex-col gap-1">
      <h3 class="text-xl font-bold text-slate-700 tracking-tight">{{ 'patient_fields_title' | translate }}</h3>
      <p class="text-sm text-slate-400 font-medium">{{ 'patient_fields_desc' | translate }}</p>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-10">
    <i class="pi pi-spin pi-spinner text-primary text-2xl"></i>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Each group is its own soft card rather than a plain divider: with four
         groups and up to eight fields apiece, a flat list of pills read as one
         undifferentiated wall of boxes. Slate-50 keeps it a shade under the
         page's own white card rather than nesting a second white-on-white one. -->
    <div *ngFor="let group of groups"
      class="flex flex-col gap-4 rounded-2xl border border-slate-100 bg-slate-50/60 p-5">
      <div class="flex items-center justify-between gap-3">
        <div class="flex items-center gap-2.5">
          <div class="w-7 h-7 rounded-lg bg-white border border-slate-200 flex items-center justify-center shadow-sm">
            <i class="pi text-[12px] text-slate-500" [ngClass]="groupIcon(group)"></i>
          </div>
          <span class="text-[10px] font-black text-slate-500 uppercase tracking-widest">
            {{ group.titleKey | translate }}
          </span>
        </div>
        <!-- Live read of local state, so it moves as the clinic checks boxes -
             a quick "did that change do what I meant" signal on a dense group. -->
        <span class="text-[10px] font-bold text-slate-400 tabular-nums whitespace-nowrap">
          {{ 'patient_fields_group_count' | translate: { count: selectedCount(group) } }}
        </span>
      </div>

      <p
        *ngIf="group.step === 3 && !hasContactSelected"
        class="flex items-start gap-2 rounded-xl bg-amber-50 border border-amber-200 px-3 py-2 text-xs font-medium text-amber-700">
        <i class="pi pi-exclamation-triangle mt-0.5 text-[11px]"></i>
        <span>{{ 'patient_fields_contact_required_hint' | translate }}</span>
      </p>

      <div class="flex flex-wrap gap-2">
        <label
          *ngFor="let key of group.keys"
          [class.opacity-60]="isLocked(key) || !canEdit"
          [class.cursor-pointer]="canEdit && !isLocked(key)"
          [ngClass]="values[key]
            ? 'bg-primary/5 border-primary/30'
            : 'bg-white border-slate-200 hover:border-slate-300'"
          class="inline-flex items-center gap-2 rounded-xl border px-3 py-2 transition-colors">
          <p-checkbox
            [binary]="true"
            [inputId]="'prf-' + key"
            [(ngModel)]="values[key]"
            [disabled]="isLocked(key) || !canEdit">
          </p-checkbox>
          <span
            class="text-xs font-semibold"
            [ngClass]="values[key] ? 'text-primary' : 'text-slate-600'">{{ labelKeys[key] | translate }}</span>
          <span *ngIf="isLocked(key)"
            class="inline-flex items-center gap-1 rounded-full bg-slate-100 px-1.5 py-0.5 text-[8px] font-black text-slate-400 uppercase tracking-widest">
            <i class="pi pi-lock text-[8px]"></i>{{ 'patient_fields_locked_hint' | translate }}
          </span>
        </label>
      </div>
    </div>

    <div class="flex items-center justify-end gap-3 pt-4 border-t border-slate-100">
      <app-button
        *hasPermission="'Configurações:edit'"
        [label]="'patient_fields_restore_defaults' | translate"
        variant="ghost"
        [disabled]="isSaving()"
        (onClick)="restoreDefaults()"></app-button>
      <app-button
        *hasPermission="'Configurações:edit'"
        [label]="'common_save' | translate"
        [loading]="isSaving()"
        [disabled]="isSaving() || !hasContactSelected"
        styleClass="min-w-[180px]"
        (onClick)="save()"></app-button>
    </div>
  </ng-container>
</div>
